import isString from 'hs-lodash/isString';
import isError from 'hs-lodash/isError';
import isNil from 'hs-lodash/isNil';
import isPlainObject from 'hs-lodash/isPlainObject';
// Ideally this value argument should be typed to a union type
export const getSentryExtra = value => {
  let extra = {};

  if (isNil(value)) {
    return extra;
  }

  if (isError(value)) {
    extra = Object.assign({}, extra, {
      message: value.message,
      stack: value.stack
    });
  }

  if (isString(value) && value.length > 0) {
    extra = Object.assign({}, extra, {
      message: value
    });
  }

  if (isPlainObject(value)) {
    extra = Object.assign({}, extra, {}, 'errorMessage' in value && {
      message: value.errorMessage
    }, {}, 'status' in value && {
      status: value.status
    }, {}, 'responseText' in value && {
      response: value.responseText
    }, {}, 'responseJSON' in value && 'message' in value.responseJSON && {
      responseMessage: value.responseJSON.message
    });
  }

  return extra;
};